import React, { useState } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  TableSortLabel,
  TableContainer
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import mockData from './data';
import { StatusBullet } from 'components';
import withStyles from "@material-ui/core/styles/withStyles";
import Switch from "@material-ui/core/Switch";


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    marginRight: theme.spacing(1)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  tableContainer:{
    maxHeight:500
  },
}));



const IOSSwitch = withStyles(theme => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
      <Switch
          focusVisibleClassName={classes.focusVisible}
          disableRipple
          classes={{
            root: classes.root,
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
          }}
          {...props}
      />
  );
});





const statusColors = {
  delivered: 'success',
  pending: 'info',
  refunded: 'danger'
};

const UnpaidTuitiones = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const [orders] = useState(mockData);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        title="شهریه های پرداخت نشده تاکنون"
      />
      <Divider />
      <CardContent className={classes.content}>

        <TableContainer className={classes.tableContainer}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell align="center">نام</TableCell>
                  <TableCell align="center" sortDirection="desc">
                    <Tooltip
                      enterDelay={300}
                      title="Sort"
                    >
                      <TableSortLabel
                        active
                        direction="desc"
                      >
                        تاریخ عضویت
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="center" sortDirection="desc">
                    <Tooltip
                        enterDelay={300}
                        title="Sort"
                    >
                      <TableSortLabel
                          active
                          direction="desc"
                      >
                        آخرین پرداخت شهریه
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="center">پرداخت شهریه</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orders.map(order => (
                  <TableRow
                    hover
                    key={order.id}
                  >
                    <TableCell align="center">
                      <img
                          width={24}
                          height={24}
                          alt="Product"
                          className={clsx(classes.image,classes.avatar)}
                          src={!order.imageUrl?`${process.env.PUBLIC_URL}/images/default-user-avatar.png`:order.imageUrl}
                      />
                    </TableCell>
                    <TableCell align="center">
                    <span className={classes.nameContainer}>
                      {order.ref}</span>
                    </TableCell>
                    <TableCell align="center">{order.customer.name}</TableCell>
                    <TableCell align="center">
                      {moment(order.createdAt).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell>
                            <IOSSwitch
                                // checked={state.checkedB}
                                onChange={props.onSwitch}
                                value="checkedB"
                            />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
        </TableContainer>
      </CardContent>
      <Divider />
      <CardActions className={classes.actions}>
        <Button
          color="primary"
          size="small"
          variant="text"
        >
     نمایش همه شاگردها <ArrowRightIcon />
        </Button>
      </CardActions>
    </Card>
  );
};

UnpaidTuitiones.propTypes = {
  className: PropTypes.string
};

export default UnpaidTuitiones;
